import {actionTypes} from "./actionTypes";

export const toggleAdd4DCollectionModal=()=>{
    return {
        type:actionTypes.TOGGLE_ADD_4D_COLLECTION_MODAL
    }
}